// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{margin:0;background-color:#000}#container{background-color:#fff}", "",{"version":3,"sources":["webpack://./node_modules/@appzuka/rxnano/lib/main.scss"],"names":[],"mappings":"AACA,KACI,QAAA,CACA,qBAAA,CAKJ,WACI,qBAAA","sourcesContent":["\nbody {\n    margin: 0;\n    background-color: black;\n\n\n}\n\n#container {\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
